import CupsListPage from './CupsListPage';

export default CupsListPage;
